import React, { Fragment } from 'react';
import { List } from 'antd';
import CardItem from './CardItem';

export default function CardsList({ cardsArray, total, className }) {
  return (
    <Fragment>
      <h3>Cards ({total || (Array.isArray(cardsArray) && cardsArray.length)})</h3>
      <List
        className={className}
        grid={{
          gutter: 8,
        }}
        dataSource={cardsArray}
        //loading
        renderItem={(card) => (
          <List.Item>
            <CardItem card={card} />
          </List.Item>
        )}
      />
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Cards/components/CardsList.js